import { useRef } from "react";
import { useParams } from "react-router-dom";

import { Logo } from "@/components/logo";
import { Skeleton } from "@/components/ui/skeleton";
import { useGetSharedRecording } from "@/features/recordings/api/get-shared-recording";
import { RecordingPlayer } from "@/features/recordings/components/recording-player";

import { ErrorMessage } from "../components/error-message";

export function SharedRecordingPage() {
  const { id } = useParams();
  const videoRef = useRef<HTMLVideoElement>(null);
  const {
    data: sharedRecording,
    isLoading,
    isError,
    error,
    isSuccess,
  } = useGetSharedRecording({
    id: id!,
  });

  if (isLoading) {
    return (
      <div className="h-full bg-background">
        <div className="mx-auto flex max-w-screen-xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
          <Logo />
        </div>
        <div className="mx-auto max-w-screen-xl px-4 sm:px-6 md:py-6 lg:px-8">
          <div className="mb-5 rounded-[calc(var(--radius)+2px)] border border-border p-1">
            <Skeleton className="aspect-video w-full rounded-lg bg-muted" />
          </div>
          <div className="h-6 w-3/4 animate-pulse rounded-md bg-gray-200" />
        </div>
      </div>
    );
  }

  if (isError || !isSuccess) {
    return (
      <div className="h-full bg-background">
        <div className="mx-auto flex max-w-screen-xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
          <Logo />
        </div>
        <div className="mx-auto max-w-screen-sm px-4 sm:px-6 md:py-6 lg:px-8">
          <ErrorMessage error={error} />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-full bg-background">
      <div className="mx-auto flex max-w-screen-xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <Logo />
      </div>
      <div className="mx-auto max-w-screen-xl px-4 sm:px-6 md:py-6 lg:px-8">
        <RecordingPlayer
          recording={{
            id: sharedRecording.recording.id,
            videoURL: sharedRecording.recording.videoURL,
            duration: sharedRecording.recording.duration,
            name: sharedRecording.recording.name,
            imageURL: sharedRecording.recording.imageURL,
          }}
          videoRef={videoRef}
          transcript={sharedRecording.recording.transcript || undefined}
        />

        <h1 className="mt-2 text-lg font-semibold text-foreground">
          {sharedRecording.recording.name}
        </h1>
      </div>
    </div>
  );
}
